module.exports = {
  "country": "LU",
  "artist": "Corinne Hermès",
  "song": "Si la Vie est un Cadeau",
  "year": "1983",
  "place": "1",
  "spotify": "5jSTQn4s1a7cDcjFXKA8V4"
};